
<template>
    <div>
        <component :key="options.wrapperId" v-if="options.componentName === 'CookiePolicy'" :is="CookiePolicy"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'Carousel'" :is="Carousel"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'Hero'" :is="Hero"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'LanguageSelector'" :is="LanguageSelector"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'Navigation'" :is="Navigation"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'NavigationMobile'" :is="NavigationMobile"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'Locations'" :is="Locations"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'Services'" :is="Services"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'TaggedNews'" :is="TaggedNews"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'SearchResultsSortToggle'"
            :is="SearchResultsSortToggle" v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'HistorySlider'" :is="HistorySlider"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'Overlay'" :is="Overlay"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'NewsLanding'" :is="NewsLanding"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'NewsCategory'" :is="NewsCategory"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'EventSlider'" :is="EventSlider"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'InsightsCategory'" :is="InsightsCategory"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'InsightsLanding'" :is="InsightsLanding"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'TestimonialSlider'" :is="TestimonialSlider"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'VideoButton'" :is="VideoButton"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'HomePageVideoButton'" :is="HomePageVideoButton"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'CookiePolicyToggle'" :is="CookiePolicyToggle"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'DropdownFilter'" :is="DropdownFilter"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'Professionals'" :is="Professionals"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'ProfessionalCard'" :is="ProfessionalCard"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'CardCarousel'" :is="CardCarousel"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'ImageCaptionCarousel'"
            :is="ImageCaptionCarousel" v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'CaseStudySlider'" :is="CaseStudySlider"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'CircleProgressBar'" :is="CircleProgressBar"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'FullWidthSlider'" :is="FullWidthSlider"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'RelatedNews'" :is="RelatedNews"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'CaseStudies'" :is="CaseStudies"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'PageNews'" :is="PageNews"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'PageInsights'" :is="PageInsights"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'HomePageNews'" :is="HomePageNews"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'ServicesSearchDropdown'"
            :is="ServicesSearchDropdown" v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'CareersOverlay'" :is="CareersOverlay"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'WorldwideOverlay'" :is="WorldwideOverlay"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'CompanyLogoSlider'" :is="CompanyLogoSlider"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'CardCarouselGrid'" :is="CardCarouselGrid"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'AlumniSpotlights'" :is="AlumniSpotlights"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'ProfessionalSlider'" :is="ProfessionalSlider"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'SharePDFTab'" :is="SharePDFTab"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'VideoPlayer'" :is="VideoPlayer"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'VirtualTour'" :is="VirtualTour"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'SearchAutoComplete'" :is="SearchAutoComplete"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'VideoOverlay'" :is="VideoOverlay"
            v-bind="options.componentProps"></component>
        <component :key="options.wrapperId" v-if="options.componentName === 'PodcastOverlay'" :is="PodcastOverlay"
            v-bind="options.componentProps"></component>
    </div>
</template>

<script>
import Overlay from './Global/Overlay'
import VideoButton from './Global/VideoButton'
import HomePageVideoButton from './Global/HomePageVideoButton'
import VideoOverlay from './Global/VideoOverlay'
import PodcastOverlay from './Global/PodcastOverlay'

import Carousel from './Carousel'
import Hero from './Hero'
import CookiePolicy from './CookiePolicy'
import LanguageSelector from './LanguageSelector'
import Navigation from './Navigation/Navigation'
import NavigationMobile from './Navigation/NavigationMobile'
import Locations from './Locations/Locations'
import Services from './Services/Services'
import ServicesSearchDropdown from './Services/ServicesSearchDropdown'
import TaggedNews from './RelatedContent/TaggedNews'
import RelatedNews from './RelatedContent/RelatedNews'
import PageNews from './RelatedContent/PageNews'
import PageInsights from './RelatedContent/PageInsights'
import CaseStudies from './RelatedContent/CaseStudies'
import HistorySlider from './History/HistorySlider'
import NewsCategory from './News/NewsCategory'
import NewsLanding from './News/NewsLanding'
import EventSlider from './Sliders/EventSlider'
import FullWidthSlider from './Sliders/FullWidthSlider'
import InsightsCategory from './Insights/InsightsCategory'
import InsightsLanding from './Insights/InsightsLanding'
import TestimonialSlider from './TestimonialSlider/TestimonialSlider'
import DropdownFilter from './FormFields/DropdownFilter'
import Professionals from './Professionals/Professionals'
import ProfessionalCard from './Professionals/ProfessionalCard'
import ProfessionalSlider from './Professionals/ProfessionalSlider'
import CardCarousel from './CardCarousel'
import ImageCaptionCarousel from './ImageCaptionCarousel'
import CaseStudySlider from './CaseStudies/CaseStudySlider'
import CircleProgressBar from './Global/CircleProgressBar'
import HomePageNews from './RelatedContent/HomePageNews'
import CareersOverlay from './CareersOverlay'
import WorldwideOverlay from './WorldwideOverlay'
import CompanyLogoSlider from './CompanyLogoSlider/CompanyLogoSlider'
import CardCarouselGrid from './CardCarouselGrid'
import AlumniSpotlights from './AlumniSpotlights'
import VirtualTour from './Global/VirtualTour'
import SearchAutoComplete from './Global/SearchAutoComplete'

import SearchResultsSortToggle from './SearchResults/SortToggle'
import CookiePolicyToggle from './CookiePolicy/CookiePolicyToggle'
import SharePDFTab from './Global/SharePDFTab'
import VideoPlayer from './Global/VideoPlayer'

export default {
    props: ["options"],
    components: {
        Carousel,
        Hero,
        CookiePolicy,
        LanguageSelector,
        Navigation,
        Locations,
        Services,
        NavigationMobile,
        TaggedNews,
        SearchResultsSortToggle,
        HistorySlider,
        Overlay,
        NewsCategory,
        EventSlider,
        NewsLanding,
        InsightsLanding,
        InsightsCategory,
        TestimonialSlider,
        VideoButton,
        HomePageVideoButton,
        CookiePolicyToggle,
        DropdownFilter,
        Professionals,
        ProfessionalCard,
        CardCarousel,
        CaseStudySlider,
        ImageCaptionCarousel,
        CircleProgressBar,
        FullWidthSlider,
        RelatedNews,
        CaseStudies,
        PageNews,
        PageInsights,
        HomePageNews,
        ServicesSearchDropdown,
        CareersOverlay,
        WorldwideOverlay,
        CompanyLogoSlider,
        CardCarouselGrid,
        AlumniSpotlights,
        ProfessionalSlider,
        SharePDFTab,
        VideoPlayer,
        VirtualTour,
        SearchAutoComplete,
        VideoOverlay,
        PodcastOverlay
    },
    data() {
        return {
            Carousel: 'Carousel',
            Hero: 'Hero',
            CookiePolicy: 'CookiePolicy',
            LanguageSelector: 'LanguageSelector',
            Navigation: 'Navigation',
            NavigationMobile: 'NavigationMobile',
            Locations: 'Locations',
            Services: 'Services',
            TaggedNews: 'TaggedNews',
            SearchResultsSortToggle: 'SearchResultsSortToggle',
            HistorySlider: 'HistorySlider',
            Overlay: 'Overlay',
            NewsLanding: 'NewsLanding',
            NewsCategory: 'NewsCategory',
            EventSlider: 'EventSlider',
            InsightsCategory: 'InsightsCategory',
            InsightsLanding: 'InsightsLanding',
            TestimonialSlider: 'TestimonialSlider',
            VideoButton: 'VideoButton',
            HomePageVideoButton: 'HomePageVideoButton',
            CookiePolicyToggle: 'CookiePolicyToggle',
            DropdownFilter: 'DropdownFilter',
            Professionals: 'Professionals',
            ProfessionalCard: 'ProfessionalCard',
            CardCarousel: 'CardCarousel',
            ImageCaptionCarousel: 'ImageCaptionCarousel',
            CaseStudySlider: 'CaseStudySlider',
            CircleProgressBar: 'CircleProgressBar',
            FullWidthSlider: 'FullWidthSlider',
            RelatedNews: 'RelatedNews',
            CaseStudies: 'CaseStudies',
            PageNews: 'PageNews',
            PageInsights: 'PageInsights',
            HomePageNews: 'HomePageNews',
            ServicesSearchDropdown: 'ServicesSearchDropdown',
            CareersOverlay: 'CareersOverlay',
            WorldwideOverlay: 'WorldwideOverlay',
            CompanyLogoSlider: 'CompanyLogoSlider',
            CardCarouselGrid: 'CardCarouselGrid',
            AlumniSpotlights: 'AlumniSpotlights',
            ProfessionalSlider: 'ProfessionalSlider',
            SharePDFTab: 'SharePDFTab',
            VirtualTour: 'VirtualTour',
            VideoPlayer: 'VideoPlayer',
            SearchAutoComplete: 'SearchAutoComplete',
            VideoOverlay: 'VideoOverlay',
            PodcastOverlay: 'PodcastOverlay',
        }
    }
}
</script>